import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-register" }

import { reactive, ref, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { SmsControllerService, UserControllerService } from "../../generated";
import message from "@arco-design/web-vue/es/message";
import {
  IconEmail,
  IconLock,
  IconPhone,
  IconUser,
} from "@arco-design/web-vue/es/icon";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRegisterView',
  setup(__props) {

const verityCodeProps = ref({
  disabled: false,
  error: false,
  answer: "aaaaaa",
});
// 验证码重发倒计时
const isVerityButtonDisabled = ref(false);
const coldDownTime = ref(60);
const cooldownTimer = ref<number | null>(null);
const trueCode = ref("654321");
const formRef = ref(null);
const router = useRouter();
const form = reactive({
  userAccount: "",
  userPassword: "",
  checkPassword: "",
  userMail: "",
  userPhone: "",
  verityCode: "",
  isRead: false,
} as any);
const getCode = async () => {
  if (!form.userMail || form.userMail === "") {
    message.error("请输入邮箱！");
  }
  // 启动倒计时
  if (cooldownTimer.value) {
    clearInterval(cooldownTimer.value);
    cooldownTimer.value = null;
  }
  isVerityButtonDisabled.value = true;
  coldDownTime.value = 60;
  cooldownTimer.value = window.setInterval(() => {
    if (coldDownTime.value <= 1) {
      if (cooldownTimer.value) {
        clearInterval(cooldownTimer.value);
        cooldownTimer.value = null;
      }
      isVerityButtonDisabled.value = false;
      coldDownTime.value = 60;
    } else {
      coldDownTime.value -= 1;
    }
  }, 1000);

  const res = await SmsControllerService.sendMailRegisterUsingPost(form);
  if (res.code === 0) {
    // 获取到验证码
    trueCode.value = res.data;
  }
};

onUnmounted(() => {
  if (cooldownTimer.value) {
    clearInterval(cooldownTimer.value);
    cooldownTimer.value = null;
  }
});
const onFinish = (value: any) => {
  if (value !== trueCode.value) {
    verityCodeProps.value.error = true;
    message.error("验证码错误！");
    form.verityCode = "";
  } else {
    verityCodeProps.value.error = false;
    verityCodeProps.value.disabled = true;
  }
};
const handleSubmit = async () => {
  if (!form.isRead) {
    message.error("请阅读并同意下方用户协议！");
    return false;
  }
  if (form.userAccount === "" || form.userPassword === "") {
    message.error("账号或密码不能为空！");
    return false;
  }
  const res = await UserControllerService.userRegisterUsingPost(form);
  if (res.code === 0) {
    // 注册成功，转到登录页
    await router.push({
      path: "/user/login",
      replace: true,
    });
  } else {
    message.error("注册失败" + res.message);
  }
};

const rules = {
  userAccount: [
    {
      required: true,
      message: "请输入用户名！",
    },
  ],
  userPassword: [
    {
      required: true,
      message: "请输入密码！",
    },
  ],
  checkPassword: [
    {
      required: true,
      message: "请确认密码！",
    },
    {
      validator: (value: any, cb: any) => {
        if (value !== form.userPassword) {
          cb("two passwords do not match");
        } else {
          cb();
        }
      },
    },
  ],
  userMail: [
    {
      type: "email",
      required: true,
      message: "请输入邮箱！",
    },
  ],
  userPhone: [
    {
      required: true,
      message: "请输入手机号！",
    },
    {
      validator: (value: any, cb: any) => {
        if (/^1([3456789])\d{9}$/.test(value)) {
          return true;
        } else {
          cb("手机格式不正确");
          return false;
        }
      },
    },
  ],
  verityCode: [
    {
      required: true,
      message: "请输入验证码！",
    },
    {
      minLength: 6,
      message: "验证码未填完全！",
    },
    {
      match: /^\d+$/,
      message: "应为全数字！",
    },
  ],
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_verification_code = _resolveComponent("a-verification-code")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h2", { style: {"margin-bottom":"32px"} }, "用户注册", -1)),
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      "label-align": 'right',
      layout: _ctx.horizontal,
      model: form,
      rules: rules,
      "auto-label-width": "",
      style: {"max-width":"480px","margin":"0 auto"},
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "userAccount",
          label: "用户名",
          tooltip: "用户名长度应不小于2",
          "validate-trigger": "blur"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAccount) = $event)),
              "max-length": { length: 20, errorOnly: true },
              "allow-clear": "",
              placeholder: "请输入用户名",
              "show-word-limit": ""
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconUser))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userPassword",
          label: "密码",
          tooltip: "密码长度应不小于8",
          "validate-trigger": "blur"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.userPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userPassword) = $event)),
              "allow-clear": "",
              placeholder: "请输入密码，长度应不小于8"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconLock))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "checkPassword",
          label: "确认密码",
          tooltip: "请重复输入密码加以确认",
          "validate-trigger": "blur"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.checkPassword) = $event)),
              "allow-clear": "",
              placeholder: "确认密码"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconLock))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userMail",
          label: "邮箱",
          tooltip: "用于获取验证码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userMail,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.userMail) = $event)),
              placeholder: "example@mail.com"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconEmail))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "verityCode",
          label: "验证码",
          tooltip: "输入邮箱收到的验证码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_verification_code, {
              modelValue: form.verityCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.verityCode) = $event)),
              disabled: verityCodeProps.value.disabled,
              error: verityCodeProps.value.error,
              style: {"width":"300px"},
              onFinish: onFinish
            }, null, 8, ["modelValue", "disabled", "error"]),
            _createVNode(_component_a_button, {
              style: {"margin-left":"16px"},
              type: "primary",
              onClick: getCode,
              disabled: isVerityButtonDisabled.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isVerityButtonDisabled.value ? `${coldDownTime.value}秒后可重发` : "获取验证码"), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userPhone",
          label: "手机号",
          tooltip: "用于辅助登录和找回密码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userPhone,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.userPhone) = $event)),
              placeholder: "请输入手机号"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconPhone)),
                _cache[8] || (_cache[8] = _createTextVNode(" （+86） "))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "isRead" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_checkbox, {
              modelValue: form.isRead,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.isRead) = $event))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("我已阅读并同意"),
                _createElementVNode("a", { href: "" }, "用户协议", -1)
              ])),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              "html-type": "submit",
              style: {"width":"150px","margin":"0 auto"},
              type: "primary"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("注册 ")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              style: {"width":"150px","margin":"0 auto"},
              type: "primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).back()))
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("返回 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["layout", "model"])
  ]))
}
}

})